// extracted by mini-css-extract-plugin
export var truncate = "_a-0";